"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var LogoAnimation = function LogoAnimation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 400 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "logo-loader-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "logo-animation-container",
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "rect-0",
    className: "rect"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "rect-1",
    className: "rect"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "rect-2",
    className: "rect"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "rect-3",
    className: "rect"
  })));
};

var _default = LogoAnimation;
exports["default"] = _default;